<template>
  <LoginWrapper>
    <div class="box">
      <div class="box_title">
        <h2>{{ $t('views.auth.login.passwordtemp.4380') }}</h2>
        <p class="guide_txt">{{ $t('views.auth.login.passwordtemp.6285') }}</p>
      </div>
      <ul class="password_choice">
        <li class="btn_wrap">
          <a
            href="javascript:void(0)"
            class=""
            onClick="alert_msg('pwd_email')"
          >
            <!-- TODO: Bind current user's data and obscure last 3 digits of email address (before @), then obscure second Phone box digits -->
            <span class="c_icon ico_search_email"></span>
            <div class="choice_text">
              {{ $t('views.auth.login.passwordtemp.3524') }}
            </div>
            <div class="choice_method">
              <span class="user_id">{{
                $t('views.auth.login.passwordtemp.ed')
              }}</span
              >@<span class="mail_sort">{{
                $t('views.auth.login.passwordtemp.navercom')
              }}</span>
            </div>
            <div class="next">
              <span>{{ $t('common.ui.next') }}</span>
            </div>
          </a>
        </li>
        <li class="btn_wrap">
          <a
            href="javascript:void(0)"
            class=""
            onClick="alert_msg('pwd_phone')"
          >
            <span class="c_icon ico_search_phone"></span>
            <div class="choice_text">
              {{ $t('views.auth.login.passwordtemp.535') }}
            </div>
            <div class="choice_method">
              <span class="num_first">{{
                $t('views.auth.login.passwordtemp.7890')
              }}</span>
              -
              <span class="num_middle">{{
                $t('views.auth.login.passwordtemp.9311')
              }}</span>
              -
              <span class="num_last">{{
                $t('views.auth.login.passwordtemp.3146')
              }}</span>
            </div>
            <div class="next">
              <span>{{ $t('common.ui.next') }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </LoginWrapper>
</template>

<script>
import LoginWrapper from '@/components/auth/LoginWrapper.vue'

export default {
  name: 'PasswordDelivery',

  components: { LoginWrapper },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.chk_round .text_label input:checked + em:after {
  margin-top: 4px;
  margin-left: 1px;
  width: 12px !important;
  height: 12px !important;
}
</style>
